import { defineComponent as _defineComponent } from 'vue'
import { BIconX } from "bootstrap-vue";
import useStore from "@/store/useStore";

export default /*#__PURE__*/_defineComponent({
  __name: 'simulation-badge',
  setup(__props) {

const store = useStore();

return { __sfc: true,store, BIconX }
}

})